import React from "react";

export const InputPassword = (props) => {
    return (
        <label className="form-label">Contraseña
            <input type="password" id="inputPassword" className="form-control" {...props} required />
        </label>
    );
}